import { createAsyncThunk } from '@reduxjs/toolkit'
import { ThunkConfig } from '../../../../shared/config/storeConfig/StoreSchema'
import { appHandleError } from '../../../../shared/lib/appHandleError/appHandleError'
import { ILicenseUpdate } from '../types/LicenseUpdate'
import { selectUpdateTimeFrom, selectUpdateTimeTo } from '../selectors/selectFilters'

export const fetchLicenseUpdates = createAsyncThunk<
	ILicenseUpdate[],
	string,
	ThunkConfig<string>
>('licenseUpdates/fetchLicenseUpdates', async (licenseId, thunkAPI) => {

	const { extra: { api }, rejectWithValue, getState } = thunkAPI

	const updateTimeFrom = selectUpdateTimeFrom(getState())
	const updateTimeTo = selectUpdateTimeTo(getState())

	try {
		const { data } = await api.get<{
			items: ILicenseUpdate[]
		}>(`/licenses/${licenseId}/updates`, {
			params: {
				updateTimeFrom,
				updateTimeTo
			}
		})

		if (!Array.isArray(data?.items)) {
			console.warn('fetchLicenseUpdates: unexpected response shape', data)
			return [] as ILicenseUpdate[]
		}
		return data.items
	} catch (e) {
		console.log(e)
		appHandleError(e, 'fetchLicenseUpdates', 'Failed to fetch license updates')
		return rejectWithValue('Error occurred on fetching license updates')
	}
})